import React, { Fragment } from 'react';

import PerfectScrollbar from 'react-perfect-scrollbar';
import { Hidden, Drawer } from '@material-ui/core';

import { connect } from 'react-redux';

import SidebarHeader from '../SidebarHeader';
import SidebarMenu from '../SidebarMenu';

import navItems from './navItems';

import { setSidebarToggleMobile } from '../../../store/reducers/AdminTheme';

const Sidebar = props => {
  const {
    setSidebarToggleMobile,
    sidebarToggleMobile,
  } = props;

  const closeDrawer = () => setSidebarToggleMobile(!sidebarToggleMobile);

  const sidebarMenuContent = (
    <div>
      {navItems.map((list,index) => (
        <SidebarMenu
          component="div"
          key={index}
          pages={list.content}
          title={list.label}
        />
      ))}
    </div>
  );

  return (
    <Fragment>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          open={sidebarToggleMobile}
          onClose={closeDrawer}
          variant="temporary"
          elevation={4}
          className="app-sidebar-wrapper-lg">
          <SidebarHeader />
          <PerfectScrollbar>{sidebarMenuContent}</PerfectScrollbar>
        </Drawer>
      </Hidden>
    </Fragment>
  );
};

const mapStateToProps = state => ({
  sidebarFixed: state.ThemeOptions.sidebarFixed,
  headerFixed: state.ThemeOptions.headerFixed,
  sidebarToggleMobile: state.ThemeOptions.sidebarToggleMobile
});

const mapDispatchToProps = dispatch => ({
  setSidebarToggleMobile: enable => dispatch(setSidebarToggleMobile(enable))
});

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
